import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { statusFilterTemplate, statusBodyTemplate, imageBodyTemplate } from '../../utils/filter_lib';
import api from '../../services/api';
import EmployeeEditDialog from './EmployeeEditDialog';
import UserCreateDialog from './UserCreateDialog';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Password } from 'primereact/password';
import { toast } from 'react-toastify';

export default function Employees() {
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [createVisible, setCreateVisible] = useState(false);
  const [resetDialogVisible, setResetDialogVisible] = useState(false);
  const [resettingUser, setResettingUser] = useState(null);
  const [resetPasswordValue, setResetPasswordValue] = useState('');
  const [resetLoading, setResetLoading] = useState(false);

  const fetchEmployees = async () => {
    const res = await api.get('/users');
    setEmployees(res.data);

    if (selectedEmployee) {
      const updatedSelected = res.data.find(emp => emp.id === selectedEmployee.id);
      setSelectedEmployee(updatedSelected || null);
    }
  };

  useEffect(() => {
    fetchEmployees();
  }, []);

  const onRowClick = (e) => {
    setSelectedEmployee(e.data);
    setModalVisible(true);
  };

  const openResetDialog = (employee) => {
    setResettingUser(employee);
    setResetPasswordValue('');
    setResetDialogVisible(true);
  };

  const closeResetDialog = (force = false) => {
    if (resetLoading && !force) return;
    setResetDialogVisible(false);
    setResettingUser(null);
    setResetPasswordValue('');
  };

  const handleResetPassword = async () => {
    if (!resettingUser) return;

    if (!resetPasswordValue || resetPasswordValue.length < 6) {
      toast.error('Yeni şifre en az 6 karakter olmalıdır.');
      return;
    }

    try {
      setResetLoading(true);
      await api.post(`/auth/users/${resettingUser.id}/reset-password`, {
        new_password: resetPasswordValue,
      });
      toast.success('Çalışanın şifresi başarıyla güncellendi.');
      closeResetDialog(true);
    } catch (error) {
      console.error('Şifre sıfırlanırken hata oluştu:', error);
      toast.error('Şifre güncellenemedi.');
    } finally {
      setResetLoading(false);
    }
  };

  const resetActionBodyTemplate = (rowData) => (
    <Button
      label="Şifre Sıfırla"
      icon="pi pi-refresh"
      className="p-button-text p-button-sm"
      onClick={(event) => {
        event.stopPropagation();
        openResetDialog(rowData);
      }}
    />
  );

  const resetDialogFooter = (
    <div className="flex justify-content-end gap-2">
      <Button
        label="İptal"
        className="p-button-text"
        onClick={() => closeResetDialog()}
        disabled={resetLoading}
      />
      <Button
        label="Kaydet"
        icon="pi pi-check"
        onClick={handleResetPassword}
        loading={resetLoading}
      />
    </div>
  );

  return (
    <div>
      <h2>Çalışan Listesi</h2>

      <DataTable
        value={employees}
        header="Çalışanlar"
        paginator
        rows={5}
        stripedRows
        onRowClick={onRowClick}
        filterDisplay="row"
      >
        <Column header="Görsel" body={imageBodyTemplate} />
        <Column field="first_name" header="Ad" filter filterPlaceholder="Ara..." filterMatchMode="contains" />
        <Column field="last_name" header="Soyad" filter filterPlaceholder="Ara..." filterMatchMode="contains" />
        <Column field="email" header="Email" filter filterPlaceholder="Ara..." filterMatchMode="contains" />
        <Column field="phone_number" header="Telefon" filter filterPlaceholder="Ara..." filterMatchMode="contains" />
        <Column
          field="is_active"
          header="Durum"
          body={statusBodyTemplate}
          filter
          filterMatchMode="equals"
          filterElement={statusFilterTemplate}
        />
        <Column header="Şifre" body={resetActionBodyTemplate} style={{ minWidth: '10rem' }} />
      </DataTable>

      <EmployeeEditDialog
        employee={selectedEmployee}
        visible={modalVisible}
        onHide={() => setModalVisible(false)}
        onSave={fetchEmployees}
      />

      <div className="flex justify-content-end mb-3">
        <Button label="Yeni Çalışan Ekle" icon="pi pi-user-plus" onClick={() => setCreateVisible(true)} />
      </div>

      <UserCreateDialog
        visible={createVisible}
        onHide={() => setCreateVisible(false)}
        onSave={fetchEmployees}
      />

      <Dialog
        header="Şifre Sıfırla"
        visible={resetDialogVisible}
        style={{ width: '400px' }}
        modal
        onHide={() => closeResetDialog()}
        footer={resetDialogFooter}
        closable={!resetLoading}
      >
        <div className="flex flex-column gap-3">
          <p className="m-0 text-sm">
            {resettingUser ? `${resettingUser.first_name} ${resettingUser.last_name}` : ''} kullanıcısı için yeni şifre belirleyin.
          </p>
          <Password
            value={resetPasswordValue}
            onChange={(e) => setResetPasswordValue(e.target.value)}
            toggleMask
            feedback={false}
            inputClassName="w-full"
            className="w-full"
            disabled={resetLoading}
          />
        </div>
      </Dialog>
    </div>
  );
}
